<template>
  <div class='TabelaBairroView'>
    <bairro-item
    v-for="(data, key) in FreteTabelaBairro"
    :key="key"
    :data="data"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BairroItem from './BairroItem'
export default {
  name: 'TabelaBairroView',
  components: { BairroItem },
  computed: {
    ...mapGetters(['FreteTabelaBairro'])
  },
  methods: {
    ...mapActions(['GetFreteBairro'])
  },
  created () {
    this.GetFreteBairro()
  }
}
</script>

<style scoped>
.TabelaBairroView {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  width: 100%;
  margin-top: 1%;
}
</style>
